import qs from 'querystringify';
import remote from './remote';

const URL = {
  ADD: '/cms/clients',
  UPDATE: '/cms/clients',
  DELETE: '/cms/clients',
  GET: '/cms/clients?pageCount=200',
  GET_DETAIL: '/cms/clients',
  GET_BOARD_INFO: '/cms/client/board',
  GET_ORGAN_CLIENTS: '/cms/clients/organ',
  GET_SCHEDULES_HOLIDAYS: '/cms/clients/schedule',
  UPDATE_HOLIDAYS: '/cms/clients/holiday',
  UPDATE_SCHEDULES: '/cms/clients/schedule',
  CLIENT_CONTROL: '/cms/control',
  //GET_EVENT_ALARM: '/cms/client/alarm',
  GET_EVENT_ALARM: '/cms/client/missing',
  GET_WEATHER: '/cms/client/weather',
  GET_LIST: '/cms/clients',
  GET_MONITORING: '/cms/monitoring',
  UPDATE_MONITORING: '/cms/monitoring',
  GET_MAIN_BOARD_INFO: '/cms/client/board/main',
  GET_CLIENT_MENU: '/cms/client/board/menu',
  GET_NOTICE_INFO: '/cms/client/board/notice',
  GET_MONTH_EVENT: '/cms/client/event',
  GET_IFRAME_PAGE: '/cms/client/external',
  GET_CONFIG_CODE: '/cms/client/code',
  GET_CLIENT_INFO: '/cms/client',
  GET_CLIENT_BOARD_LIST: '/cms/client/board/list',
};

export default {
  getClientInfo(clientId) {
    return remote.request({
      url: remote.getUrl(URL.GET_CLIENT_INFO) + '/' + clientId,
    });
  },
  addClient(client) {
    return remote.request({
      url: remote.getUrl(URL.ADD),
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: client,
    });
  },
  updateClient(client) {
    return remote.request({
      url: remote.getUrl(URL.UPDATE) + '/' + client.clientId,
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: client,
    });
  },
  getEventBoardInfo(clientId, boardIndex, monthNumber) {
    let url = remote.getUrl(URL.GET_MONTH_EVENT),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
        monthNumber: monthNumber,
      };
    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getClient(clientId) {
    return remote.request({
      url: clientId ? remote.getUrl(URL.GET_DETAIL) + '/' + clientId : remote.getUrl(URL.GET),
    });
  },
  getOrganClients(organId) {
    return remote.request({
      url: remote.getUrl(URL.GET_ORGAN_CLIENTS) + '/' + organId,
    });
  },
  getBoardInfo(clientId, boardIndex, templteType, urgentYn) {
    let url = remote.getUrl(URL.GET_BOARD_INFO),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
      };

    if (templteType) {
      requestData.templateType = templteType;
    }

    if (urgentYn) {
      requestData.urgentYn = urgentYn;
    }

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getEventAlarm(clientId, boardIndex, alarmId) {
    let url = remote.getUrl(URL.GET_EVENT_ALARM),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
        alarmId: alarmId,
      };

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
    });
  },
  deleteClient(clientId) {
    return remote.request({
      url: remote.getUrl(URL.DELETE),
      method: remote.METHOD.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      data: Array.isArray(clientId) ? clientId : [clientId],
    });
  },
  getSchedulesAndHolidays() {
    return remote.request({
      url: remote.getUrl(URL.GET_SCHEDULES_HOLIDAYS),
    });
  },
  updateSchedules(schedules) {
    return remote.request({
      url: remote.getUrl(URL.UPDATE_SCHEDULES),
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: schedules,
    });
  },
  updateHolidays(holidays) {
    return remote.request({
      url: remote.getUrl(URL.UPDATE_HOLIDAYS),
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: holidays,
    });
  },
  controlClient(clientId, action) {
    return remote.request({
      url: remote.getUrl(URL.CLIENT_CONTROL),
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        clientId: clientId,
        action: action,
      },
    });
  },
  getClientList() {
    /** 클라이언트 모니터링 2021.09.25 */
    return remote.request({
      url: remote.getUrl(URL.GET_LIST),
    });
  },
  getBoardCaptureImgs(clientId) {
    /** 클라이언트 모니터링 2021.09.25 */
    return remote.request({
      url: remote.getUrl(URL.GET_MONITORING) + '/' + clientId,
    });
  },
  updateMonitoring(data) {
    return remote.request({
      url: remote.getUrl(URL.UPDATE_MONITORING) + '/' + data.clientId,
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  getMainBoardInfo(clientId, boardIndex, templteType, urgentYn) {
    let url = remote.getUrl(URL.GET_MAIN_BOARD_INFO),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
      };

    if (templteType) {
      requestData.templateType = templteType;
    }

    if (urgentYn) {
      requestData.urgentYn = urgentYn;
    }

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getMenuList(clientId) {
    /** 클라이언트 메뉴리스트 2022.09.25 */
    let url = remote.getUrl(URL.GET_CLIENT_MENU),
      requestData = {
        clientId: clientId,
      };

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getNoticeInfo(clientId, boardIndex) {
    let url = remote.getUrl(URL.GET_NOTICE_INFO),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
      };

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },

  getExternalPage(clientId, boardIndex) {
    let url = remote.getUrl(URL.GET_IFRAME_PAGE),
      requestData = {
        clientId: clientId,
        boardIndex: boardIndex,
      };

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getTimeoutInfo(codeGrp) {
    let url = remote.getUrl(URL.GET_CONFIG_CODE),
      requestData = {
        codeGrp: codeGrp,
      };

    return remote.request({
      url: url + '?' + new Date() + '&' + qs.stringify(requestData),
      timeout: 60000,
      // 30000 에서 60초로 늘림
    });
  },
  getClientBoardList(clientId) {
    return remote.request({
      url: remote.getUrl(URL.GET_CLIENT_BOARD_LIST) + '/' + clientId,
    });
  },
};
